var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.81 9.985H24V6.169C23.622 6.117 22.322 6 20.808 6c-3.158 0-5.322 1.987-5.322 5.639V15H12v4.266h3.486V30h4.273V19.267h3.345l.531-4.266h-3.877v-2.939c.001-1.233.333-2.077 2.051-2.077z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
};

export default __webpack_public_path__ + "static/media/facebook.3fe949a9.svg";
export { SvgFacebook as ReactComponent };